import { ApprovalStepStatus } from '~/data/proposals';

export const getProcessStepApprovalStatusColor = (
  status: ApprovalStepStatus,
): string => {
  switch (status) {
    case ApprovalStepStatus.APPROVED:
      return 'success';
    case ApprovalStepStatus.PENDING:
      return 'warning';
    case ApprovalStepStatus.REJECTED:
      return 'error';
  }
};
